

import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class OperationErrors extends Vue {
    @Prop({required: true, type: String}) action!: string;
    @Prop({required: true, type: Array, default: []}) errorMessages!: string[];

    public static $liveCreate(parent: Vue, action: string, errorMessages: string[]) {
        return parent.$createElement(OperationErrors, {
            props: {
                action: action,
                errorMessages: errorMessages
            }
        });
    }
}
